<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <div :class="((isDesktop && inlineNumber !== 4) || isMobile) && 'flex'">
      <figure
        class="h-[46px] w-[46px] basis-[46px] tablet:h-[78px] tablet:w-[78px] tablet:basis-[78px] desktop:h-20 desktop:w-20 desktop:basis-20"
      >
        <img
          :src="contextThumbnail"
          :alt="itemData.name || itemData.description"
          class="pointer-events-none block h-full w-full"
        />
      </figure>
      <div class="w-full flex-1 pt-2 tablet:pt-0">
        <div
          class="relative w-full pl-3 pr-6 tablet:pl-0 tablet:pr-0"
          :class="inlineNumber !== 4 && 'desktop:pl-6'"
        >
          <h3
            v-if="itemData.name"
            class="line-clamp-1 text-sm font-bold leading-6 tablet:mb-1 tablet:line-clamp-2 tablet:text-base"
            :class="isOpen && 'mb-2.5 tablet:mb-1'"
          >
            {{ itemData.name }}
          </h3>
          <p
            v-if="itemData.description && !isMobile"
            class="element-description text-sm leading-5 text-gray-600 tablet:line-clamp-6"
            v-html="provideSanitized(itemData.description)"
          />
          <button
            v-if="isMobile"
            class="absolute right-0 top-0 h-6 w-6"
            @click="handleClick"
          >
            <IconCaret
              :direction="isOpen ? 'up' : 'down'"
              class="h-full w-full text-blue-400"
            />
          </button>
        </div>
      </div>
    </div>
    <p
      v-if="itemData.description && isMobile && isOpen"
      class="element-description pt-1 text-sm leading-5 text-gray-600"
      v-html="provideSanitized(itemData.description)"
    />
  </div>
</template>

<script setup lang="ts">
  import type { IItem } from '@/components/Shared/Suite/ListIcon/index.vue';
  import type { TUrlConnector } from '@/components/Shared/Suite/type.ts';

  interface IProps {
    itemData: IItem;
    itemIndex: number;
    inlineNumber: 2 | 3 | 4;
    urlConnector?: TUrlConnector;
  }

  const props = defineProps<IProps>();

  const { isMobile, isDesktop } = useScreen();
  const { provideResponsiveImgUrl } = useSolutionsData();

  const isOpen = ref<boolean>(props.itemIndex === 0);

  const contextThumbnail = computed((): string => {
    const { thumbnail } = props.itemData;
    if (!thumbnail) return '';

    if (props.urlConnector === 'solution') {
      return provideResponsiveImgUrl(thumbnail);
    }
    return thumbnail;
  });

  const handleClick = (): void => {
    isOpen.value = !isOpen.value;
  };
</script>

<style lang="scss" scoped>
  .element-description:deep(a) {
    @apply font-bold text-blue-400 underline;
  }

  .element-description:deep(ul) {
    padding-left: 1.75rem; // 28px
    list-style-type: disc;
  }

  .element-description:deep(ol) {
    padding-left: 1.5rem;
    list-style-type: decimal;
  }
</style>
